import { post } from '../base';
const endPoint = 'auth/';

const login = async (body) => {
  const response = await post(`${endPoint}login`, body);
  return response;
};

export const authAPI = {
  login,
};
